// base/actions.js

export const makeJsaBaseActions = ({ setJsaUi, bump }) => ({
  setActiveJsaTab(tabName) {
    setJsaUi({ base: (prev) => ({ ...prev, activeJsaTab: tabName }) });
    bump();
  },

  setIsEmbeddedInForm(isEmbedded) {
    setJsaUi({ base: (prev) => ({ ...prev, isEmbeddedInForm: isEmbedded }) });
    bump();
  },
});
